import * as XLSX from "xlsx";

// ---------------- EXCEL ----------------
export const parseExcel = (file, callback) => {
  const reader = new FileReader();
  reader.onload = (evt) => {
    const wb = XLSX.read(evt.target.result, { type: "binary" });
    const ws = wb.Sheets[wb.SheetNames[0]];
    const json = XLSX.utils.sheet_to_json(ws, { defval: "" });
    callback(json);
  };
  reader.readAsBinaryString(file);
};

// ---------------- VALIDACIONES ----------------

export const requiredColumns = [
  "Tipo_id",
  "Identificacion",
  "APIM",
  "Tipo_APIM",
  "Fuente_APIM",
  "Fecha_APIM",
  "Data_APIM1",
  "Cantidad_APIM",
  "consecutivo",
];

export const validateExcelRows = (rows) => {
  const results = {};

  rows.forEach((row, idx) => {
    const missing = requiredColumns
      .filter((col) => !row[col] || row[col].toString().trim() === "")
      .map((col) => ({
        column: col,
        message: " - No puede ser vacío",
      }));

    results[idx] = { valid: missing.length === 0, missing };
  });

  return results;
};

// ---------------- TRANSFORMACIONES ----------------

export const transformFormDataToPayload = (form) => ({
  ...form,
  APIM: Number(form.APIM) || 0,
  Tipo_APIM: Number(form.Tipo_APIM) || 0,
  Cantidad_APIM: Number(form.Cantidad_APIM) || 0,
  consecutivo: Number(form.consecutivo) || 0,
});

export const transformExcelRowsToPayload = (rows) =>
  rows.map((row) => ({
    Factura: row.Factura || "",
    Tipo_id: row.Tipo_id || "",
    Identificacion: row.Identificacion || "",
    APIM: Number(row.APIM) || 0,
    Tipo_APIM: Number(row.Tipo_APIM) || 0,
    Fuente_APIM: row.Fuente_APIM || "",
    Fecha_APIM: row.Fecha_APIM
      ? new Date(row.Fecha_APIM).toISOString().split("T")[0]
      : "",
    Data_APIM1: row.Data_APIM1 || "",
    Cantidad_APIM: Number(row.Cantidad_APIM) || 0,
    Cod_Diagnostico: row.Cod_Diagnostico || "",
    ID_Prestador: row.ID_Prestador || "",
    Tipo_ID_prestador: row.Tipo_ID_prestador || "",
    consecutivo: Number(row.consecutivo) || 0,
  }));
